var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.982,
    height: 28.882,
    viewBox: "0 0 43.982 28.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_421",
    "data-name": "Grupo 421",
    transform: "translate(-11709.224 -1376.709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_196_",
    transform: "translate(11710.224 1377.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_199_",
    d: "M544.383,28.9a2.793,2.793,0,0,0-.526-1.142l-7.976-9.245-.054-.054a3.514,3.514,0,0,0-2.791-1.36h-26.9a3.528,3.528,0,0,0-3.535,3.535V40.448a3.528,3.528,0,0,0,3.535,3.535h26.9a3.568,3.568,0,0,0,2.791-1.36l.054-.054,7.958-9.245a4.254,4.254,0,0,0,.743-2.737A6.929,6.929,0,0,0,544.383,28.9Z",
    transform: "translate(-502.6 -17.1)",
    fill: "none",
    stroke: "#e51b26",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_158_",
    transform: "translate(11723.946 1386.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_160_",
    d: "M581.019,66.86a1.247,1.247,0,0,1-.4.943,1.327,1.327,0,0,1-.961.4,1.26,1.26,0,0,1-.961-.4,1.316,1.316,0,0,1-.4-.943,1.259,1.259,0,0,1,.4-.961,1.359,1.359,0,0,1,.961-.4,1.315,1.315,0,0,1,.961.4A1.286,1.286,0,0,1,581.019,66.86Z",
    transform: "translate(-578.3 -65.5)",
    fill: "#e51b26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_154_",
    transform: "translate(11723.946 1392.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_155_",
    d: "M581.019,102.16a1.247,1.247,0,0,1-.4.943,1.327,1.327,0,0,1-.961.4,1.26,1.26,0,0,1-.961-.4,1.316,1.316,0,0,1-.4-.943,1.259,1.259,0,0,1,.4-.961,1.359,1.359,0,0,1,.961-.4,1.315,1.315,0,0,1,.961.4A1.259,1.259,0,0,1,581.019,102.16Z",
    transform: "translate(-578.3 -100.8)",
    fill: "#e51b26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_150_",
    transform: "translate(11728.532 1382.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_151_",
    d: "M608.15,52.328a14.319,14.319,0,0,1-2.628,8.139,1.052,1.052,0,0,1-.888.489.947.947,0,0,1-.689-.29.937.937,0,0,1-.308-.689,1.469,1.469,0,0,1,.163-.526,16.2,16.2,0,0,0,2.012-7.124,15.682,15.682,0,0,0-2.048-7.124,1.473,1.473,0,0,1-.163-.526.967.967,0,0,1,.308-.689,1.028,1.028,0,0,1,.725-.29,1.045,1.045,0,0,1,.87.489,13.32,13.32,0,0,1,1.939,3.861A13.065,13.065,0,0,1,608.15,52.328Z",
    transform: "translate(-603.6 -43.7)",
    fill: "#e51b26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_147_",
    transform: "translate(11745.861 1389.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_148_",
    d: "M702.136,84.468A1.468,1.468,0,1,1,700.668,83,1.462,1.462,0,0,1,702.136,84.468Z",
    transform: "translate(-699.2 -83)",
    fill: "#e51b26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredex);
export default __webpack_public_path__ + "static/media/credex.33f3a4218d2ad990cb6a57f8a4b73cf8.svg";
export { ForwardRef as ReactComponent };